import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { FINDINGS_UPDATED_SSE_EVENT } from '@terra/shared-contracts-findings';
import { useSSE } from '../app/providers/SseProvider';
import { FINDINGS_QUERY_KEY } from './api/useFindings';
import { FINDING_BY_ID_QUERY_KEY } from './api/useFindingById';

export function useFindingsUpdatedSSE() {
  const { subscribe } = useSSE();
  const queryClient = useQueryClient();

  useEffect(() => {
    return subscribe(FINDINGS_UPDATED_SSE_EVENT, () => {
      queryClient.removeQueries({
        queryKey: [FINDINGS_QUERY_KEY],
        exact: false,
        type: 'inactive',
      });
      queryClient.removeQueries({
        queryKey: [FINDING_BY_ID_QUERY_KEY],
        exact: false,
        type: 'inactive',
      });
      void queryClient.invalidateQueries({
        queryKey: [FINDINGS_QUERY_KEY],
        exact: false,
        refetchType: 'active',
      });
      void queryClient.invalidateQueries({
        queryKey: [FINDING_BY_ID_QUERY_KEY],
        exact: false,
        refetchType: 'active',
      });
    });
  }, [queryClient, subscribe]);
}
